import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { UsersComponent } from './components/users/users.component';
import { RolesComponent } from './components/roles/roles.component';
import { authGuard } from './auth-guard';
import { SettingsComponent } from './components/settings/settings.component';
import { SystemConfigurationSettingsComponent } from './components/system.config.setting/system.config.setting.component';
import { UserGroupsComponent } from './components/usergroups/usergroups.component';
import { SessionTimeoutComponent } from './components/session-timeout/session-timeout.component';

export const routes: Routes = [
    {
    path: 'sessiontimeout',
    component: SessionTimeoutComponent
  },
	{ path: 'login', component: LoginComponent },
	{
    path: 'profilemanagement',
    canActivate: [authGuard], // Guard the whole section
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'users', component: UsersComponent },
      { path: 'roles', component: RolesComponent },
      { path: 'settings', component: SettingsComponent },
      {path: 'systemconfigurationsettings', component:SystemConfigurationSettingsComponent},
      {path: 'usergroups', component:UserGroupsComponent}
    ]
  },
  
  { path: '', redirectTo: 'profilemanagement/dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: 'login' } // Catch-all for 404s
];
